import Typography from "@mui/material/Typography"
import React from "react"
import Box from "@mui/material/Box"

export const StatCard = ({ icon, label, value, focus = true, minWidth = "auto" }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      px: 3,
      py: 1.8,
      color: "#999",
      minWidth,
    }}
  >
    <Box
      sx={{
        display: "flex",
        color: focus ? "#c49654" : "#999",
        "& svg": {
          fontSize: {
            xs: 40,
            md: 50,
          },
          strokeWidth: 1,
        },
      }}
    >
      {icon}
    </Box>

    <Box>
      <Typography
        sx={{
          fontWeight: 800,
          mb: 1,
          fontSize: 13,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          mt: 0.5,
          fontSize: {
            xs: 18,
            md: 22,
          },
          fontWeight: 900,
          lineHeight: 1.1,
          color: focus ? "#c49654" : "#eee",
        }}
      >
        {value}
      </Typography>
    </Box>
  </Box>
)
